import {RouteDefinition} from '../../../routes';
import {STPEditorListScreen} from './STPEditorListScreen';
import {STPEditorContentListScreen} from './STPEditorContentListScreen';
import {STPEditorContentEditScreen} from './STPEditorContentEditScreen';

export const STPEditorRoutes: RouteDefinition[] = [
    {
        routerLink: '/settings/stp-editor',
        component: STPEditorListScreen,
    },
    {
        routerLink: '/settings/stp-editor/:id',
        component: STPEditorContentListScreen,
    },
    {
        routerLink: '/settings/stp-editor/:device_id/content/',
        component: STPEditorContentEditScreen,
    },
    {
        routerLink: '/settings/stp-editor/:device_id/content/:id',
        component: STPEditorContentEditScreen,
    },
];
